import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'toGatewayIcon',
  standalone: true
})
export class ToGatewayIconPipe implements PipeTransform {
  constructor() {
  }
  
  public transform(value?: string): string {
    switch (value?.toUpperCase()) {
      case "ONLINE":
        return "icons/gateway-active.svg"
      case "OFFLINE":
        return "icons/gateway-inactive.svg"
      default:
        return "icons/gateway-inactive.svg"
    }
  }
}